import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AccountLinkPrompt } from './AccountLinkPrompt';

export const AccountLinkConfirmations = ({ user }) => {
  const [links, setLinks] = useState([]);
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [error, setError] = useState('');
  const [owner, setOwner] = useState(null);
  const inFlight = useRef(false);
  const generation = useRef(0);
  const userId = user?.user_id;
  useEffect(() => {
    generation.current += 1;
    setOwner(userId);
    setLinks([]);
    setDismissed(false);
    setError('');
    setBusy(false);
    inFlight.current = false;
    if (!userId) return;
    let active = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/account-links/pending`, { withCredentials: true })
      .then(({ data }) => { if (active) setLinks(data.links || []); }).catch(() => {});
    return () => { active = false; generation.current += 1; };
  }, [userId]);
  if (owner !== userId || dismissed || !links.length) return null;
  const link = links[0];
  const confirm = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    const requestGeneration = generation.current;
    setBusy(true);
    setError('');
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/events/${link.game_type}/${encodeURIComponent(link.event_id)}/players/${encodeURIComponent(link.player_id)}/confirm-link`, {}, { withCredentials: true });
      if (requestGeneration !== generation.current) return;
      setLinks(previous => previous.slice(1));
      toast.success('Account link confirmed');
    } catch {
      if (requestGeneration !== generation.current) return;
      setError('Could not confirm this player entry. Please try again.');
      toast.error('Could not confirm this link. Please try again.');
    } finally {
      if (requestGeneration === generation.current) { setBusy(false); inFlight.current = false; }
    }
  };
  return <AccountLinkPrompt link={link} count={links.length} busy={busy} error={error}
    onConfirm={confirm} onDismiss={() => setDismissed(true)} />;
};